import React, { memo } from 'react';
import { formats } from 'investira.sdk';
import { HighchartsReact } from 'investira.react.charts';

const TipoAtivoChart = memo(props => {
  const { data = [] } = props;

  const processData = data => {
    const xData = Object.values(data);
    const xTotal = xData.reduce((sum, item) => sum + Math.abs(item.financeiro_diferenca), 0);
    const xThreshold = xTotal * 0.01; // 1% do total
    const xMainData = {};

    let xOthersSumFinanceiro = 0;
    let xOthersSumQuantidade = 0;
    let xOthersSumAtivos = 0;

    Object.entries(data).forEach(([xKey, xItem]) => {
      if (Math.abs(xItem.financeiro_diferenca) >= xThreshold) {
        xMainData[xKey] = xItem;
      } else {
        xOthersSumFinanceiro += xItem.financeiro_diferenca;
        xOthersSumQuantidade += xItem.quantidade_diferenca;
        xOthersSumAtivos += xItem.quantidade_ativos;
      }
    });

    if (xOthersSumFinanceiro > 0) {
      xMainData.OUTROS = {
        financeiro_diferenca: xOthersSumFinanceiro,
        quantidade_diferenca: xOthersSumQuantidade,
        quantidade_ativos: xOthersSumAtivos
      };
    }

    return xMainData;
  };

  const reduceData = (pData = [], pGroupBy = 'mercado', pNameKey = 'setor') => {
    let xGrouped = pData.reduce((xAcc, xItem) => {
      const xKey = xItem[pGroupBy];

      if (!xAcc[xKey]) {
        xAcc[xKey] = {
          financeiro_diferenca: 0,
          quantidade_diferenca: 0,
          quantidade_ativos: 0
        };
      }

      xAcc[xKey].ativo_tipo = xItem.ativo_tipo;
      xAcc[xKey].financeiro_diferenca += xItem.financeiro_diferenca;
      xAcc[xKey].quantidade_diferenca += xItem.quantidade_diferenca;
      xAcc[xKey].quantidade_ativos += xItem.quantidade_ativos;

      return xAcc;
    }, {});

    xGrouped = processData(xGrouped);

    const xResult = Object.entries(xGrouped).map(([xKey, xValue]) => {
      if (xValue.quantidade_diferenca === 0 && xValue.financeiro_diferenca === 0) {
        return {
          name: '',
          metadata: {
            quantidade_ativos: 0,
            financeiro_diferenca: 0,
            quantidade_diferenca: 0
          }
        };
      }

      if (xKey === 'OUTROS') {
        return {
          name: 'Outros',
          y: xValue.financeiro_diferenca,
          dataLabels: {
            color: '#FFFFFF' // Set the color of data labels to red
          },
          metadata: {
            quantidade_ativos: xValue.quantidade_ativos,
            financeiro_diferenca: formats.formatNumber(xValue.financeiro_diferenca, 2, true, true),
            quantidade_diferenca: formats.formatNumber(xValue.quantidade_diferenca, 6, true)
          }
        };
      }

      return {
        name: xValue[pNameKey],
        y: xValue.financeiro_diferenca,
        dataLabels: {
          color: '#FFFFFF' // Set the color of data labels to red
        },
        metadata: {
          quantidade_ativos: xValue.quantidade_ativos,
          financeiro_diferenca: formats.formatNumber(xValue.financeiro_diferenca, 2, true, true),
          quantidade_diferenca: formats.formatNumber(xValue.quantidade_diferenca, 6, true)
        }
      };
    });
    return xResult;
  };

  const xData = reduceData(data, 'ativo_tipo_id', 'ativo_tipo');

  const xOptions = {
    chart: {
      type: 'bar',
      height: '320px'
    },
    title: false,
    xAxis: {
      categories: xData.map(xItem => xItem.name),
      title: {
        text: null
      },
      gridlineWidth: 0,
      lineWidth: 0
    },
    yAxis: {
      title: {
        text: null
      }
    },
    plotOptions: {
      bar: {
        borderRadius: '50%',
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.metadata.financeiro_diferenca}</span><br/><span style="color: #FFFFFF; text-decoration: none;">${this.point.metadata.quantidade_diferenca}</span>`;
          },
          groupPadding: 0.1
        }
      }
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000
      },
      pointFormat: `Financeiro Diferença: <b>{point.metadata.financeiro_diferenca}</b><br>Quantidade Diferença: <b>{point.metadata.quantidade_diferenca}</b>`
    },
    series: [
      {
        name: 'Tipo de Ativo',
        colorByPoint: true,
        data: xData,
        maxPointWidth: 40
      }
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600
          }
        }
      ]
    },
    legend: {
      enabled: false
    }
  };

  return <HighchartsReact options={xOptions} />;
});

export default TipoAtivoChart;
